<template>
  <div class="rv">
    <div id="heading">
      <div class="header-icon fa fa-bus"></div>
      <h1>Recreational Vehicle Insurance</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>The Road Less Traveled</h2>
          </div>

          <p>The thrill of adventure – it’s what owning a recreational vehicle is all about.
            Whatever your interest, be it cruising on your motorcycle or exploring the road less traveled on your
            ATV, SIG & Associates offers advanced coverage options to meet the insurance needs of the adventurer in
            everyone.</p>
          <p>Whether you’re an experienced outdoor enthusiast or just starting out,
            we have a policy to fit your needs. From RVs and boats to ATVs, SIG & Associates can ensure
            the safety of both you and your vehicle. Our insurance options provide you with the same service
            and rich features you can expect – from comprehensive and collision coverage to personal injury protection
            and
            towing costs.</p>
          <p>We offer a variety of Recreational Vehicle Insurance packages, such as:</p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="boat">
              Boat Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="motorcycle">
              Motorcycle Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="motorhome">
              Motorhome Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="atv">
              ATV Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="snowmobile">
              Snowmobile Insurance
            </li>
          </ul>

          <div class="text-center">
            <h2>Why Recreational Vehicle Insurance?</h2>
          </div>
          <p>Owning a recreational vehicle can be a dream come true. It gives you the freedom to travel and the capability
          to explore new places, but with freedom comes responsibility. Should an accident happen – such as property
          damage, vandalism, or bodily injury as a result of a crash – it’s reassuring to know that your investment is
          protected.</p>

          <p>With Recreational Vehicle Insurance from SIG & Associates, you can continue living the dream with confidence,
          knowing that you, your vehicle, and your passengers are protected. Contact one of our representatives today to
          find a package that works best for you.</p>

          <p>SIG & Associates provides Recreational Vehicle Insurance to adventurers near Wichita Falls, Haslet, Decatur,
          Prosper, Vernon, and Garland.</p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import rvHelper from '../helpers/rvHelper.js'

Object.defineProperty(Vue.prototype, '$rvHelper', {value: rvHelper})
Vue.component('modal')

export default {
  name: 'Recreational Vehicle',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$rvHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/RV.vue